export default __webpack_public_path__ + "c7e084de0ae6cca3999c3d8abb466203.png";